<template>
  <div id="app">
    <menuHeader/>
    <router-view/>
  </div>
</template>

<script>
import menuHeader from "./components/Header";
export default {
  components: {
    menuHeader
  }
};
</script>


<style>
.fade-enter-active {
  transition: all 1s;
  display: inline-block;
}
.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.home {
  margin: 5px;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.b-checkbox {
  margin: 5px;
}
.b-image {
  width: 200px;
  height: 150px;
}
</style>
